import React, { useState } from 'react';
import {
  SectionContainer,
  SectionTitle,
  CardsContainer,
  Card,
  CardIcon,
  CardTitle,
  CardDescription,
  ProgressBar,
  ProgressIndicator,
  CTAButton,
  ArrowIcon
} from './styles';
import dollarIcon from '../../../assets/images/dollar-icon.svg';
import messageIcon from '../../../assets/images/message-icon.svg';
import noCardCreditIcon from '../../../assets/images/no-credit-card.svg';
import arrowUpRight from '../../../assets/images/arrow-up-right.svg';
import { trackFacebookEvent } from '../../../utils/metaPixels';

const FeaturesCards = () => {
  const [activeCard, setActiveCard] = useState(1);

  const features = [
    {
      icon: dollarIcon,
      title: "Sin pagos anticipados, ni riesgos",
      description: ""
    },
    {
      icon: noCardCreditIcon,
      title: "Sin tarjeta, sin cuenta bancaria, sin complicaciones.",
      description: ""
    },
    {
      icon: messageIcon,
      title: "Solo pagas cuando el acceso llega a tus manos.",
      description: ""
    }
  ];

  const handleRedirectToMarketplace = () => {
    trackFacebookEvent({
      event: 'Lead',
      content_name: 'Haz tu primer pedido sin riesgos',
      page: window.location.pathname
    });

    window.location.href = process.env.REACT_APP_URL_MARKETPLACE;
  };

  return (
    <SectionContainer>
      <SectionTitle>
        Compra online sin pagar por adelantado
      </SectionTitle>

      <CardsContainer>
        {features.map((feature, index) => (
          <Card
            key={index}
            active={activeCard === index}
            onClick={() => setActiveCard(index)}
          >
            <CardIcon active={activeCard === index}>
              <img src={feature.icon} alt={`Ícono ${index + 1}`} />
            </CardIcon>
            <CardTitle active={activeCard === index}>{feature.title}</CardTitle>
            <CardDescription active={activeCard === index}>{feature.description}</CardDescription>
          </Card>
        ))}
      </CardsContainer>

      <ProgressBar>
        <ProgressIndicator position={activeCard} />
      </ProgressBar>

      <CTAButton onClick={handleRedirectToMarketplace}>
        Haz tu primer pedido sin riesgos.<ArrowIcon src={arrowUpRight} alt="Flecha" />
      </CTAButton>
    </SectionContainer>
  );
};

export default FeaturesCards;